import io from 'socket.io-client/dist/socket.io.js'

import notificationBypass from './lib/NotificationBypass.js'
import { logOut } from './lib/APIClient.js'
import { getText } from './lib/text'
import ActionTypes from './actions/ActionTypes'

let socket = null
let connectionsCount = 0

export function send(x: any) {
  if (!socket) {
    console.error(`can't send message, socket: ${socket}`)
    return
  }
  socket.send(x)
}

export function emit(n, x) {
  if (!socket) {
    console.error(`can't emit, socket: ${socket}`)
    return
  }
  socket.emit(n, x)
}

export function startSocket(mySessionKey, store, onReconnection) {
  const address = `${location.protocol}//${location.host}`

  socket = io(address, {
    reconnection: true,
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 6
  })

  socket.on("start", data => {
    console.log(`[ IO ] start event (reconnection #${connectionsCount}, ${JSON.stringify(data)})`)

    notificationBypass.notify(getText("connection_stablished"), {level: "success"})
    if (connectionsCount > 0) onReconnection()
    connectionsCount++
  })

  socket.on("message", message => {
    console.log(`[ IO ] message ${message}`)
    notificationBypass.notify(`Message: ${message}`)
  })

  socket.on("update", data => {
    console.log(`[ IO ] update`)
    if (data.sessionKey != mySessionKey) {
      store.dispatch({
        type: ActionTypes.SERVER_UPDATE,
        payload: data
      })
    }
  })

  socket.on("disconnect", data => {
    console.log(`[ IO ] disconnect, gonna logOut (${JSON.stringify(data)})`)

    const notify = () => notificationBypass.notify(
      `Error: ${JSON.stringify(data)}`,
      { title: getText("connection_lost"), level: "error" }
    )

    const interval = setInterval(
      () => {
        if (socket.connected) clearInterval(interval)
        else notify()
      },
      6 * 1000
    )

    notify()

    // logOut()
    //   .then(() => { window.location.href = ("/login") })
    //   .catch(reason => console.error(reason))
  })

  return socket.id
}

export default startSocket
